var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaxAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 3.67589L8.88442 2.5418C7.17748 2.09837 5.70255 2.98294 5.21633 4.74224L4.09417 8.80254C3.60932 10.5569 4.43046 12.0379 6.1374 12.4813L10.5029 13.6154C12.2099 14.0589 13.6798 13.173 14.1646 11.4187L15.2868 7.35836C15.773 5.59906 14.9569 4.11932 13.25 3.67589Z",
    fill: "url(#paint0_linear_9308_7537)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_9308_7537)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.18494,
    height: 7.27927,
    rx: 2.1243,
    transform: "matrix(0.306585 -0.951843 0.955408 0.29529 5.10181 10.3723)",
    fill: "#8237FF"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.51066,
    y: -0.792891,
    width: 22.5472,
    height: 22.3036
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.55px)",
      clipPath: "url(#bgblur_0_9308_7537_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 5.09831
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_9308_7537",
    maskUnits: "userSpaceOnUse",
    x: -0.199951,
    y: 3.51782,
    width: 14,
    height: 13,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.199951,
    y: 3.51782,
    width: 14,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35078 4.51782H4.18099C2.15958 4.51782 0.800049 5.908 0.800049 7.97573V12.7479C0.800049 14.8098 2.15958 16.1999 4.18099 16.1999H9.35078C11.3722 16.1999 12.7258 14.8098 12.7258 12.7479V7.97573C12.7258 5.908 11.3722 4.51782 9.35078 4.51782Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.35078 4.51782H4.18099C2.15958 4.51782 0.800049 5.908 0.800049 7.97573V12.7479C0.800049 14.8098 2.15958 16.1999 4.18099 16.1999H9.35078C11.3722 16.1999 12.7258 14.8098 12.7258 12.7479V7.97573C12.7258 5.908 11.3722 4.51782 9.35078 4.51782Z",
    fill: "#BA90FF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35078 4.73025C9.4681 4.73025 9.56321 4.63514 9.56321 4.51782C9.56321 4.4005 9.4681 4.30539 9.35078 4.30539V4.73025ZM9.35078 4.30539C9.23346 4.30539 9.13835 4.4005 9.13835 4.51782C9.13835 4.63514 9.23346 4.73025 9.35078 4.73025V4.30539ZM9.35078 4.51782V4.30539H4.18099V4.51782V4.73025H9.35078V4.51782ZM4.18099 4.51782V4.30539C3.12009 4.30539 2.21775 4.67125 1.5806 5.32286C0.943856 5.97406 0.587619 6.89455 0.587619 7.97573H0.800049H1.01248C1.01248 6.98918 1.33601 6.18071 1.88438 5.61989C2.43234 5.05948 3.22048 4.73025 4.18099 4.73025V4.51782ZM0.800049 7.97573H0.587619V12.7479H0.800049H1.01248V7.97573H0.800049ZM0.800049 12.7479H0.587619C0.587619 13.8263 0.943956 14.7453 1.58069 15.3957C2.21781 16.0465 3.12009 16.4124 4.18099 16.4124V16.1999V15.9875C3.22047 15.9875 2.43228 15.6583 1.88429 15.0985C1.33591 14.5384 1.01248 13.7314 1.01248 12.7479H0.800049ZM4.18099 16.1999V16.4124H9.35078V16.1999V15.9875H4.18099V16.1999ZM9.35078 16.1999V16.4124C10.4117 16.4124 11.3126 16.0465 11.9483 15.3955C12.5835 14.745 12.9382 13.826 12.9382 12.7479H12.7258H12.5133C12.5133 13.7316 12.1912 14.5387 11.6443 15.0987C11.0978 15.6583 10.3113 15.9875 9.35078 15.9875V16.1999ZM12.7258 12.7479H12.9382V7.97573H12.7258H12.5133V12.7479H12.7258ZM12.7258 7.97573H12.9382C12.9382 6.89481 12.5836 5.97435 11.9484 5.32305C11.3127 4.67128 10.4117 4.30539 9.35078 4.30539V4.51782V4.73025C10.3112 4.73025 11.0978 5.05945 11.6442 5.6197C12.1911 6.18042 12.5133 6.98892 12.5133 7.97573H12.7258Z",
    fill: "url(#paint1_linear_9308_7537)",
    mask: "url(#path-3-outside-1_9308_7537)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.189533,
    y: 6.47225,
    width: 13.1411,
    height: 7.77425
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.59px)",
      clipPath: "url(#bgblur_1_9308_7537_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7537)",
    "data-figma-bg-blur-radius": 3.18644
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_9308_7537",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37598 10.359C3.37598 10.7445 3.69797 11.06 4.09152 11.06C4.48507 11.06 4.80706 10.7445 4.80706 10.359C4.80706 9.97352 4.48507 9.65869 4.09152 9.65869C3.69797 9.65869 3.37598 9.97352 3.37598 10.359ZM6.76289 11.06C6.36934 11.06 6.04735 10.7446 6.04735 10.3591C6.04735 9.97355 6.36934 9.65872 6.76289 9.65872C7.15644 9.65872 7.47843 9.97355 7.47843 10.3591C7.47843 10.7446 7.15644 11.06 6.76289 11.06ZM9.43455 11.06C9.041 11.06 8.71901 10.7446 8.71901 10.3591C8.71901 9.97358 9.041 9.65875 9.43455 9.65875C9.82809 9.65875 10.1441 9.97358 10.1441 10.3591C10.1441 10.7446 9.82809 11.06 9.43455 11.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37598 10.359C3.37598 10.7445 3.69797 11.06 4.09152 11.06C4.48507 11.06 4.80706 10.7445 4.80706 10.359C4.80706 9.97352 4.48507 9.65869 4.09152 9.65869C3.69797 9.65869 3.37598 9.97352 3.37598 10.359ZM6.76289 11.06C6.36934 11.06 6.04735 10.7446 6.04735 10.3591C6.04735 9.97355 6.36934 9.65872 6.76289 9.65872C7.15644 9.65872 7.47843 9.97355 7.47843 10.3591C7.47843 10.7446 7.15644 11.06 6.76289 11.06ZM9.43455 11.06C9.041 11.06 8.71901 10.7446 8.71901 10.3591C8.71901 9.97358 9.041 9.65875 9.43455 9.65875C9.82809 9.65875 10.1441 9.97358 10.1441 10.3591C10.1441 10.7446 9.82809 11.06 9.43455 11.06Z",
    fill: "url(#paint2_linear_9308_7537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09152 11.06V10.975C3.74324 10.975 3.46095 10.696 3.46095 10.359H3.37598H3.291C3.291 10.7931 3.6527 11.1449 4.09152 11.1449V11.06ZM4.80706 10.359H4.72209C4.72209 10.696 4.4398 10.975 4.09152 10.975V11.06V11.1449C4.53033 11.1449 4.89203 10.7931 4.89203 10.359H4.80706ZM4.09152 9.65869V9.74366C4.43989 9.74366 4.72209 10.0222 4.72209 10.359H4.80706H4.89203C4.89203 9.92486 4.53024 9.57372 4.09152 9.57372V9.65869ZM3.37598 10.359H3.46095C3.46095 10.0222 3.74314 9.74366 4.09152 9.74366V9.65869V9.57372C3.6528 9.57372 3.291 9.92486 3.291 10.359H3.37598ZM6.04735 10.3591H5.96238C5.96238 10.7931 6.32408 11.145 6.76289 11.145V11.06V10.975C6.41461 10.975 6.13232 10.696 6.13232 10.3591H6.04735ZM6.76289 9.65872V9.57375C6.32417 9.57375 5.96238 9.92489 5.96238 10.3591H6.04735H6.13232C6.13232 10.0222 6.41452 9.74369 6.76289 9.74369V9.65872ZM7.47843 10.3591H7.56341C7.56341 9.92489 7.20161 9.57375 6.76289 9.57375V9.65872V9.74369C7.11127 9.74369 7.39346 10.0222 7.39346 10.3591H7.47843ZM6.76289 11.06V11.145C7.20171 11.145 7.56341 10.7931 7.56341 10.3591H7.47843H7.39346C7.39346 10.696 7.11117 10.975 6.76289 10.975V11.06ZM8.71901 10.3591H8.63403C8.63403 10.7932 8.99573 11.145 9.43455 11.145V11.06V10.975C9.08627 10.975 8.80398 10.696 8.80398 10.3591H8.71901ZM9.43455 9.65875V9.57378C8.99582 9.57378 8.63403 9.92492 8.63403 10.3591H8.71901H8.80398C8.80398 10.0222 9.08617 9.74372 9.43455 9.74372V9.65875ZM10.1441 10.3591H10.2291C10.2291 9.92584 9.8742 9.57378 9.43455 9.57378V9.65875V9.74372C9.78199 9.74372 10.0592 10.0213 10.0592 10.3591H10.1441ZM9.43455 11.06V11.145C9.87429 11.145 10.2291 10.7923 10.2291 10.3591H10.1441H10.0592C10.0592 10.697 9.78189 10.975 9.43455 10.975V11.06Z",
    fill: "url(#paint3_linear_9308_7537)",
    mask: "url(#path-5-inside-2_9308_7537)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7537",
    x: 1.40204,
    y: -0.18365,
    width: 16.557,
    height: 16.4225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1243,
    result: "effect1_foregroundBlur_9308_7537"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7537_clip_path",
    transform: "translate(4.51066 0.792891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.35078 4.51782H4.18099C2.15958 4.51782 0.800049 5.908 0.800049 7.97573V12.7479C0.800049 14.8098 2.15958 16.1999 4.18099 16.1999H9.35078C11.3722 16.1999 12.7258 14.8098 12.7258 12.7479V7.97573C12.7258 5.908 11.3722 4.51782 9.35078 4.51782Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7537",
    x: 0.189533,
    y: 6.47225,
    width: 13.1411,
    height: 7.77425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.06215,
    dy: 1.06215
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.06215
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7537",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7537_clip_path",
    transform: "translate(-0.189533 -6.47225)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37598 10.359C3.37598 10.7445 3.69797 11.06 4.09152 11.06C4.48507 11.06 4.80706 10.7445 4.80706 10.359C4.80706 9.97352 4.48507 9.65869 4.09152 9.65869C3.69797 9.65869 3.37598 9.97352 3.37598 10.359ZM6.76289 11.06C6.36934 11.06 6.04735 10.7446 6.04735 10.3591C6.04735 9.97355 6.36934 9.65872 6.76289 9.65872C7.15644 9.65872 7.47843 9.97355 7.47843 10.3591C7.47843 10.7446 7.15644 11.06 6.76289 11.06ZM9.43455 11.06C9.041 11.06 8.71901 10.7446 8.71901 10.3591C8.71901 9.97358 9.041 9.65875 9.43455 9.65875C9.82809 9.65875 10.1441 9.97358 10.1441 10.3591C10.1441 10.7446 9.82809 11.06 9.43455 11.06Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7537",
    x1: 11.053,
    y1: 3.09923,
    x2: 8.43232,
    y2: 13.0837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7947C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7537",
    x1: 2.69843,
    y1: 5.8788,
    x2: 10.1165,
    y2: 15.2579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7537",
    x1: 9.66414,
    y1: 9.91176,
    x2: 2.2998,
    y2: 11.0714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7537",
    x1: 4.45333,
    y1: 9.82196,
    x2: 4.75079,
    y2: 11.6012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxAdmin);
export default __webpack_public_path__ + "static/media/taxAdmin.b33ab70101e201a393b64589533a85b1.svg";
export { ForwardRef as ReactComponent };